import React, { Component } from 'react';
import { components } from 'react-select';

const SingleValue = ({ children, ...props }) => {
    return (
        <components.SingleValue {...props}>{children}</components.SingleValue>
    );
};

export default SingleValue;